module.exports = __webpack_public_path__ + "img/hohlsaum_alugrau_ral7037.fb0cb833.jpg";